<template>
    <div class="cell-renderer-online rater-buttons-wrapper">
      <div class="rater-buttons d-flex">
        <vs-button
            class="mr-2"
            size="small"
            color="secondary"
            :disabled="!onlineRateGuid"
            @click="onlineClicked"
        >
          Online
        </vs-button>
      </div>
    </div>
</template>

<script>
export default {
  name: 'CellRendererOnline',
  data() {
    return {
      customParams: null,
    }
  },
  computed: {
    onlineRaterTypeId() {
      return this.params.onlineRaterCol.ID;
    },
    onlineRaterType() {
      return this.params.onlineRaterCol.Document_Type;
    },
    onlineRateGuid() {
      if (!this.params || !this.params.data) {
        return '';
      }

      return this.params.data[`DocumentType_${this.onlineRaterTypeId}`];
    },
  },
  methods: {
    onlineClicked() {
      this.download(
          this.onlineRateGuid,
          this.onlineRaterType,
          this.onlineRaterTypeId
      )
    },
    download(documentGuid, documentType, documentTypeId) {
      console.log(documentGuid)
      console.log(documentType)
      console.log(documentTypeId)
      console.log('--------------')

      this.$parent.$emit('online', {documentGuid, documentType, documentTypeId});
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/custom/components/variables';
  .cell-renderer-online {
    .rater-buttons-wrapper {
      height: 100%;
      display: flex;
      align-items: center;

      .rater-buttons {
        .onlinerater-button {
          &.disabled {
            cursor: initial;
          }

          > button:hover {
            background-color: #fff !important;
          }  
        }

        button {
          padding: 4px 10px !important;

          span {
            font-size: 12px;
          }
        }
      }
    }
  }
</style>
